var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-tabs',{on:{"click":_vm.check_eval}},[_c('van-tab',{attrs:{"title":"待评论","name":"staylist"}}),_vm._v(" "),_c('van-tab',{attrs:{"title":"已评价","name":"commlist"}})],1),_vm._v(" "),_c(_vm.list,{tag:"div",staticClass:"body"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfd2e29a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stay/evaluation_admin.vue
// module id = null
// module chunks = 